if (!customElements.get('boltlink-purchase')) {
  // Resolve linked color/size choices before Dawn requests the selected variant.
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects.bl-variant-picker');
    if (!picker || !event.target.matches('input[type="radio"]')) return;
    const groups = Array.from(picker.querySelectorAll('fieldset'));
    const changedIndex = groups.indexOf(event.target.closest('fieldset'));
    const selected = groups.map((group) => group.querySelector('input:checked')?.value);
    const variants = JSON.parse(picker.querySelector('[data-boltlink-variants]').textContent);
    if (variants.some((variant) => variant.options.every((value, index) => value === selected[index]))) return;
    const candidates = variants.filter((variant) => variant.options[changedIndex] === event.target.value);
    const matching = candidates.find((variant) => variant.available) || candidates[0];
    if (!matching) return;
    groups.forEach((group, index) => {
      const input = Array.from(group.querySelectorAll('input')).find((item) => item.value === matching.options[index]);
      if (input) input.checked = true;
      const label = group.querySelector('[data-selected-value]');
      if (label) label.textContent = matching.options[index];
    });
  }, true);
  customElements.define(
    'boltlink-purchase',
    class BoltlinkPurchase extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        this.button = this.querySelector('[data-purchase-submit]');
        this.price = this.querySelector('[data-purchase-price]');
        this.onClick = () => {
          const { form, submit } = this.getNativeControls();
          this.sync();
          if (!form || !submit || this.button.disabled) return;
          if (!form.reportValidity()) return;
          // Keep Dawn's variant ID, quantity, validation and cart handling as the single purchase path.
          form.requestSubmit(submit);
          this.sync();
        };
        this.button.addEventListener('click', this.onClick);
        // Dawn replaces price/option markup and changes button state during variant and cart requests.
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => !this.contains(record.target))) this.sync();
        });
        this.observer.observe(this.productInfo, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'value'],
        });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
      }

      getNativeControls() {
        const sectionId = this.productInfo.dataset.section;
        return {
          form: this.productInfo.querySelector(`#product-form-${sectionId}`),
          submit: this.productInfo.querySelector(`#ProductSubmitButton-${sectionId}`),
        };
      }

      sync() {
        const { form, submit } = this.getNativeControls();
        const variantInput = form?.querySelector('input[name="id"]');
        const error = form?.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        const hasError = error && !error.hidden && error.textContent.trim();
        this.hidden = !form || !submit || Boolean(hasError);
        if (hasError && hasError !== this.lastError) {
          error.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        this.lastError = hasError;
        const unavailable =
          !variantInput || variantInput.disabled || !/^\d+$/.test(variantInput.value);
        this.button.disabled =
          unavailable || !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        const label = submit?.querySelector('span')?.textContent.trim() || '';
        if (this.button.textContent !== label) this.button.textContent = label;
        const sourcePrice = this.productInfo.querySelector(`#price-${this.productInfo.dataset.section}`);
        const priceSelector = sourcePrice?.querySelector('.price--on-sale')
          ? '.price-item--sale'
          : '.price__regular .price-item--regular';
        const priceText = sourcePrice && !sourcePrice.classList.contains('hidden')
          ? sourcePrice.querySelector(priceSelector)?.textContent.trim() || ''
          : '';
        if (this.price.textContent !== priceText) this.price.textContent = priceText;
      }
    }
  );
}
